/*

OBSOLETE: file now hosted here /frontend/js/

*/


/* global window, document, fetch */

document.addEventListener('DOMContentLoaded', function () {

    // --- Elemente (IDs müssen zu deinem Markup passen) ---
    var gate             = document.getElementById('contact-gate');           // Button-Auswahl
    var sectionOrder     = document.getElementById('contact-order-login');    // Login + Ergebnis
    var sectionGeneral   = document.getElementById('contact-general');        // normales Kontaktformular
    var form             = document.getElementById('order-login-form');       // Login-Form
    var err              = document.getElementById('order-login-error');      // Fehlerbox
    var result           = document.getElementById('order-status-result');    // Container für Übersicht

    // Falls Seite anders aufgebaut ist, lieber fail-safe:
    if (!gate || !sectionOrder || !sectionGeneral || !result || !form) {
        return;
    }

    // ----------------------------------------------------
    // AUTO-OPEN via URL hash
    // /kontakt#customer  -> Login (Bestellstatus)
    // /kontakt#general   -> normales Kontaktformular
    // ----------------------------------------------------
    function openFromHash() {
        var raw = (window.location.hash || "").replace(/^#/, ""); // "#" weg
        if (!raw) return;

        var lower = raw.toLowerCase();

        // 1) simple hashes
        if (lower === "customer") {
            showSection("order");
            return;
        }
        if (lower === "general") {
            showSection("general");
            return;
        }

        // 2) params aus Hash lesen (case-insensitive)
        var params = {};
        raw.split("&").forEach(function (pair) {
            var parts = pair.split("=");
            if (parts.length >= 2) {
            var key = decodeURIComponent(parts[0]).toLowerCase();
            var val = decodeURIComponent(parts.slice(1).join("=")); // falls "=" im Wert
            params[key] = val;
            }
        });

        // orderid / order / ordernumber akzeptieren
        var orderId = params.orderid || params.order || params.ordernumber || "";
        var emailVal = params.email || "";

        if (orderId) {
            showSection("order");

            // Bestellnummer eintragen
            var orderInput = document.querySelector('#order-login-form input[name="orderNumber"]');
            if (orderInput) {
            orderId = orderId.trim();
            if (orderId[0] !== "#") orderId = "#" + orderId; // immer mit Raute
            orderInput.value = orderId;
            }

            // Email eintragen, wenn vorhanden
            if (emailVal) {
            var emailInput = document.querySelector('#order-login-form input[name="email"]');
            if (emailInput) emailInput.value = emailVal.trim();
            }

            return;
        }
    }


    // ----------------------------------------------------
    // SECTION SWITCHING (Gate)
    // ----------------------------------------------------
    function showSection(target) {
        gate.style.display = 'none';
        sectionOrder.style.display   = (target === 'order') ? 'block' : 'none';
        sectionGeneral.style.display = (target === 'general') ? 'block' : 'none';
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function backToGate() {
        gate.style.display = 'block';
        sectionOrder.style.display = 'none';
        sectionGeneral.style.display = 'none';
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    gate.querySelectorAll('[data-target]').forEach(function (btn) {
        btn.addEventListener('click', function () {
        showSection(btn.dataset.target);
        });
    });

    document.querySelectorAll('[data-back]').forEach(function (btn) {
        btn.addEventListener('click', backToGate);
    });

    openFromHash();
    window.addEventListener('hashchange', openFromHash);

    // ----------------------------------------------------
    // LOGIN SUBMIT -> AJAX
    // ----------------------------------------------------
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        err.style.display = 'none';
        result.innerHTML = '';

        var email = form.email.value.trim();
        var orderNumber = form.orderNumber.value.trim();
        if (!email || !orderNumber) return;

        result.innerHTML = '<p>Lade Bestellinfos…</p>';

        fetch(window.ORDER_STATUS_CONFIG.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, orderNumber: orderNumber })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
            if (!data || !data.success) {
            err.textContent = (data && data.message) ? data.message : 'Fehler';
            err.style.display = 'block';
            result.innerHTML = '';
            return;
            }

            renderOrder(data.order || {});
            hideLoginIntroButKeepResult();
        })
        .catch(function (e2) {
            console.error("Order-UI error:", e2);
            err.textContent = 'Technischer Fehler.';
            err.style.display = 'block';
            result.innerHTML = '';
        });
    });

    function hideLoginIntroButKeepResult(){
        var backBtn = document.getElementById('contact-back-btn');
        var kids = sectionOrder.children;

        for (var i = 0; i < kids.length; i++) {
            if (kids[i] !== result && kids[i] !== backBtn) {
            kids[i].style.display = 'none';
            }
        }
        result.style.display = 'block';
        if (backBtn) backBtn.style.display = 'block';
    }

    function ensureDefaultSubject(order){
        var subjEl = document.getElementById('os-question-subject');
        if (!subjEl) return;

        // nur setzen, wenn noch leer
        if (!subjEl.value.trim()){
            var num = order && order.number ? order.number : '';
            subjEl.value = "Eine Frage zu Bestellung #" + num;
        }
    }

    // ----------------------------------------------------
    // RENDER ORDER UI
    // ----------------------------------------------------
    function renderOrder(order) {
        order = order || {};
        var items = Array.isArray(order.line_items) ? order.line_items : [];
        var prod  = order.production || {};

        // ---- Adress-Fallbackprüfung (neue Requirement #2) ----
        // Backend darf das gern aktiv setzen:
        // order.address_issue = true/false
        // order.address_issue_reason = "Lieferadresse fehlerhaft ..."
        var addressIssue = !!order.address_issue;
        var addressIssueReason = order.address_issue_reason || '';

        if (!addressIssue) {
        var shipAddr = order.shipping_address || {};
        var addrCheck = checkAddressIssue(shipAddr);
        addressIssue = addrCheck.issue;
        addressIssueReason = addrCheck.reason;
        }

        // ---- Production UI bestimmen ----
        var prodUI = computeProductionUI(prod);

        // Wenn Adresse kaputt: override auf rot + Text + Service-Button
        if (addressIssue) {
            prodUI = {
                label: "Lieferadresse fehlerhaft oder unvollständig",
                hint: addressIssueReason || "Bitte überprüfe deine Lieferadresse. Unser Service hilft dir gern weiter.",
                colorClass: "os-red",
                cancellable: false,
                showSupportButton: true,
                supportPrefill: {
                subject: "#" + (order.number || "") + " - Lieferadresse fehlerhaft",
                message:
                    "Hallo SmilePoster-Team,\n\n" +
                    "hier ist meine vollständige Lieferanschrift:\n\n\n" +
                    "Vielen Dank!"
                }
            };
        }

        // ---- Karten bauen ----
        var headerHtml =
        '<div class="os-header">' +
            '<div class="os-title">Bestellung #' + safe(order.number) + '</div>' +
            '<div class="os-sub">Bestätigt am ' + safe(order.created_at) + '</div>' +
        '</div>';

        var productionCardHtml = buildProductionCard(prodUI, prod, order);

        var shippingCardHtml = buildShippingCard(order);

        var itemsCardHtml = buildItemsCard(items, order);

        var addressCardHtml = buildAddressCard(order);

        var questionHtml = buildQuestionBlock();

        var modalHtml =
        '<div id="os-modal-backdrop" class="os-modal-backdrop">' +
            '<div class="os-modal">' +
            '<button type="button" id="os-modal-close" class="os-modal-close">×</button>' +
            '<img id="os-modal-img" alt="" />' +
            '</div>' +
        '</div>';

        var haltModalHtml = `
        <div id="os-halt-modal">
            <div class="os-modal-backdrop"></div>

            <div class="os-modal-box" role="dialog" aria-modal="true" aria-labelledby="os-halt-title">
            <div class="os-modal-header">
                <div id="os-halt-title" class="os-modal-title">Druckauftrag anhalten?</div>
                <button type="button" class="os-modal-close" id="os-halt-close" aria-label="Schließen">×</button>
            </div>

            <div class="os-modal-body">
                <p>
                Bitte brich den Auftrag nur ab, wenn Du Dir sicher bist, dass ein Fehler vorliegt. Teile uns im Anschluss mit, wie wir mit der Bestellung fortfahren sollen.
                </p>
                <p class="os-modal-warn">
                Achtung: Dieser Schritt kann nicht rückgängig gemacht werden.
                </p>
            </div>

            <div class="os-modal-actions">
                <button type="button" class="os-btn os-btn-ghost" id="os-halt-cancel">
                Nein, zurück
                </button>
                <button type="button" class="os-btn os-btn-primary" id="os-halt-confirm">
                Ja, Druckauftrag anhalten
                </button>
            </div>
            </div>
        </div>
        `;


        result.innerHTML =
        '<div class="os-wrap">' +
            headerHtml +
            productionCardHtml +
            shippingCardHtml +
            itemsCardHtml +
            addressCardHtml +
            questionHtml +
            haltModalHtml +
            modalHtml +
        '</div>';

        // ---- Handler binden ----
        bindImageModal();
        bindQuestionForm(order);
        bindCancelRequestHandler(order);     // keine MO & <24h → Anfrage
        bindSupportButton(order, prodUI);    // Service-Kontakt (Adresse kaputt oder force_contact etc.)
        bindMerchOneHaltHandler(order);      // neue Requirement #1

        // KEIN auto-open/scroll mehr
    }

    // ----------------------------------------------------
    // PRODUCTION CARD
    // Requirement #1: solange ACCEPTED → Button "Druckauftrag anhalten"
    // ----------------------------------------------------
    function buildProductionCard(prodUI, prod, order){
        var supportBtnHtml = '';
        if (prodUI.showSupportButton || (prod && prod.force_contact)) {
            supportBtnHtml =
            '<div style="margin-top:10px;">' +
                '<button type="button" class="os-support-btn" id="os-support-btn">Service kontaktieren</button>' +
            '</div>';
        }

        var haltBtnHtml = '';
        if (prod) {
            if (prod.status === 'ACCEPTED' || prod.status === 'DRAFT') {
                haltBtnHtml =
                '<div class="os-halt">' +
                    '<button type="button" id="os-halt-btn" class="os-halt-btn">Druckauftrag anhalten</button>' +
                    '<div class="os-halt-sub">Solange die Produktion noch nicht gestartet ist, kannst Du den Druckauftrag anhalten. Aktuell befindet sich diese Möglichkeit noch in der Testphase, so dass wir einen Erfolg nicht garantieren können. Das Anhalten des Druckauftrages stellt keine Stornierung der Bestellung dar.</div>' +
                '</div>';
            }

            if (prod.status === 'CANCELLED') {
                haltBtnHtml = 
                '<div style="margin-top:10px;">' +
                    '<button type="button" class="os-support-btn" id="os-support-btn">Service kontaktieren</button>' +
                '</div>';
            }
        }

        return '' +
            '<div class="os-card os-card-prod">' +
            '<div class="os-status-row">' +
                '<div class="os-pulse ' + prodUI.colorClass + '"></div>' +
                '<div><strong>' + prodUI.label + '</strong></div>' +
            '</div>' +
            (prodUI.hint ? '<div class="os-status-hint">' + prodUI.hint + '</div>' : '') +
            supportBtnHtml +
            haltBtnHtml +
            buildCancelRequestBlock(prodUI, order) +
            '</div>';
    }

    function buildCancelRequestBlock(prodUI, order){
        var prod = order.production || {};

        // Wenn MerchOne schon ACCEPTED ist → nur Halt-Button, KEIN Storno-Anfrage-Block
        if (prod.status === 'ACCEPTED') return '';
        if (prod.status === 'DRAFT') return '';
        if (prod.status === 'CANCELLED') return '';
        if (!prodUI.cancellable) return '';

        return '' +
            '<div class="os-cancel">' +
            '<div class="os-cancel-title">Druckauftrag abbrechen</div>' +
            '<div class="os-cancel-text">Solange die Produktion noch nicht gestartet ist, kannst du eine unverbindliche Storno-Anfrage senden.</div>' +
            '<button type="button" id="os-cancel-btn" class="os-cancel-btn">Storno anfragen</button>' +
            '</div>';
    }

    // ----------------------------------------------------
    // SHIPPING CARD
    // ----------------------------------------------------
    function buildShippingCard(order){
        var shippingInfo = order.fulfillments || [];

        console.log(shippingInfo);

        var text = 'Sobald eine Sendungsnummer vorliegt, findet Du hier den Link zur Sendungsverfolgung. Du erhältst auch eine Benachrichtigung per Email';
        var infoText = 'Ihr Paket befindet sich im Versand. Die Abholung erfolgt üblicherweise am selben oder nächsten Werktag nach Fertigstellung. Sobald das Paket im Eingangsdepot unseres Versandpartners erfasst wurde, ändert sich der Status. Bis dahin gilt es trotz Abholung als angekündigt.';
        var linkHtml = '';
        if (Array.isArray(shippingInfo) && shippingInfo.length > 0) {
            shippingInfo.forEach(function(si){
                if (si.url) {
                    linkHtml = '<a href="' + si.url + '" target="_blank" rel="noopener">Sendung verfolgen</a>';
                    text = safe(si.company) + ' ' + safe(si.number);
                }
            });
        }

        return '' +
            '<div class="os-card os-card-ship">' +
            (linkHtml ? '<div class="os-ship-line">' + text + '</div><div>' + linkHtml + '</div><div class="os-ship-info">'+ infoText +'</div>' : '<div class="os-ship-line">' + text + '</div>') +
            '</div>';
    }

    // ----------------------------------------------------
    // ITEMS CARD (mit attrs)
    // ----------------------------------------------------
    function buildItemsCard(items, order){
        var rows = '';

        items.forEach(function(it){
            var title = safe(it.title);
            var qty   = safe(it.quantity);
            var variant   = safe(it.variant);
            var price = safe(it.price);
            var cur   = safe(it.currency || order.currency || 'EUR');
            var img   = it.image ? safe(it.image) : '';

            var attrsHtml = '';
            var attrs = it.attrs || {};
            for (var k in attrs) {
            if (!attrs.hasOwnProperty(k)) continue;
            var v = attrs[k];
            if (v === null || v === undefined || String(v).trim() === '') v = '-';
            attrsHtml +=
                '<div class="os-attr-row"><span class="os-attr-key">' + k + ':</span> ' +
                '<span class="os-attr-val">' + v + '</span></div>';
            }

            rows += '' +
            '<div class="os-item-row">' +
                '<div class="os-item-img">' +
                (img
                    ? '<img src="' + img + '" data-zoom="' + img + '" alt=""/>' 
                    : ''
                ) +
                '</div>' +
                '<div class="os-item-meta">' +
                '<div class="os-item-title">' + title + '</div>' +
                '<div class="os-item-qty">' + qty + 'x ' + variant + '</div>' +
                (attrsHtml ? '<div class="os-attrs">' + attrsHtml + '</div>' : '') +
                '</div>' +
                '<div class="os-item-price">' + price + ' ' + cur + '</div>' +
            '</div>';
        });

        return '' +
            '<div class="os-card os-card-items">' +
            rows +
            '<div class="os-totals">' +
                '<div class="os-total-row"><span>Zwischensumme</span><span>' + safe(order.subtotal) + ' ' + safe(order.currency) + '</span></div>' +
                '<div class="os-total-row"><span>Versand</span><span>' + safe(order.shipping_cost) + '</span></div>' +
                '<div class="os-total-row os-total-grand"><span>Gesamt</span><span>' + safe(order.total) + ' ' + safe(order.currency) + '</span></div>' +
            '</div>' +
            '</div>';
    }

    // ----------------------------------------------------
    // ADDRESS CARD
    // ----------------------------------------------------
    function buildAddressCard(order){
        var ship = order.shipping_address || {};
        var bill = order.billing_address || {};

        return '' +
        '<div class="os-card os-card-addr">' +
            '<div class="os-addr-grid">' +
            '<div>' +
                '<div class="os-addr-title">Kontaktinformationen</div>' +
                '<div>' + safe(order.customer_email) + '</div>' +
                '<div class="os-addr-title" style="margin-top:10px;">Lieferadresse</div>' +
                '<div>' + formatAddress(ship) + '</div>' +
            '</div>' +
            '<div>' +
                '<div class="os-addr-title">Rechnungsadresse</div>' +
                '<div>' + formatAddress(bill) + '</div>' +
            '</div>' +
            '</div>' +
        '</div>';
    }

    function formatAddress(a){
        if (!a) return '-';
        var arr = [
        safe(a.name),
        safe(a.address1),
        safe(a.address2),
        (safe(a.zip) + ' ' + safe(a.city)).trim(),
        safe(a.country)
        ].filter(Boolean);
        return arr.length ? arr.join('<br>') : '-';
    }

    // ----------------------------------------------------
    // QUESTION BLOCK (CTA + Form getrennt Subject/Text)
    // ----------------------------------------------------
    function buildQuestionBlock(){
        return '' +
        '<div class="os-question-wrap">' +
            '<button type="button" class="os-question-cta" id="os-question-cta">' +
            'Noch Fragen offen? Klicke hier.' +
            '</button>' +

            '<div class="os-question-form" id="os-question-form">' +
            '<label class="os-question-label" for="os-question-subject">Betreff</label>' +
            '<input id="os-question-subject" type="text" placeholder="Betreff" />' +

            '<label class="os-question-label" for="os-question-text">Nachricht</label>' +
            '<textarea id="os-question-text" rows="4" placeholder="Schreib uns kurz dein Anliegen…"></textarea>' +

            '<button type="button" id="os-question-send">Nachricht senden</button>' +
            '<div id="os-question-msg" class="os-question-msg"></div>' +
            '</div>' +
        '</div>';
    }

    function showQuestionForm() {
        var form = document.getElementById('os-question-form');
        var cta  = document.getElementById('os-question-cta');
        if (form) form.style.display = 'block';
        if (cta) cta.style.display = 'none';
    }

    // ----------------------------------------------------
    // BIND QUESTION FORM SEND
    // ----------------------------------------------------
    function bindQuestionForm(order){
        var cta     = document.getElementById('os-question-cta');
        var form    = document.getElementById('os-question-form');
        var send    = document.getElementById('os-question-send');
        var subjEl  = document.getElementById('os-question-subject');
        var textEl  = document.getElementById('os-question-text');
        var msgEl   = document.getElementById('os-question-msg');

        if (!form) return;

        //console.log(order);

        if (cta) {
        cta.addEventListener('click', function(){
            ensureDefaultSubject(order);
            showQuestionForm();
            form.scrollIntoView({behavior:"smooth", block:"start"});
        });
        }

        if (!send) return;

        send.addEventListener('click', function(){
        var subject = subjEl ? subjEl.value.trim() : '';
        var text    = textEl ? textEl.value.trim() : '';

        if (!subject || !text) {
            msgEl.textContent = "Bitte Betreff und Nachricht ausfüllen.";
            return;
        }

        send.disabled = true;
        msgEl.textContent = 'Sende…';

        fetch(window.ORDER_STATUS_CONFIG.questionEndpoint || '/service/orders/mail/', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({
            orderNumber: order.number,
            email: order.customer_email,
            fromName: order.billing_address.name,
            subject: subject,
            message: text
            })
        })
        .then(function(r){ return r.json(); })
        .then(function(data){
            if (data && data.success){
            msgEl.textContent = 'Danke! Wir melden uns so schnell wie möglich.';
            if (textEl) textEl.value = '';
            } else {
            msgEl.textContent = (data && data.message) ? data.message : 'Konnte nicht gesendet werden.';
            send.disabled = false;
            }
        })
        .catch(function(e){
            console.error(e);
            msgEl.textContent = 'Technischer Fehler.';
            send.disabled = false;
        });
        });
    }

    // ----------------------------------------------------
    // CANCEL REQUEST (keine MO & <24h)
    // Öffnet nur Formular mit Prefill
    // ----------------------------------------------------
    function bindCancelRequestHandler(order) {
        var btn = document.getElementById('os-cancel-btn');
        if (!btn) return;

        btn.addEventListener('click', function () {
        var subjEl = document.getElementById('os-question-subject');
        var textEl = document.getElementById('os-question-text');
        showQuestionForm();

        if (subjEl && !subjEl.value.trim()) {
            subjEl.value = "#" + (order.number || "") + " - Bitte um Storno";
        }
        if (textEl && !textEl.value.trim()) {
            textEl.value =
            "Hallo SmilePoster-Team,\n\n" +
            "ich möchte den Druckauftrag zu Bestellung #" + (order.number || "") + " stornieren.\n" +
            "Bitte gebt mir kurz Bescheid, ob das noch möglich ist.\n\n" +
            "Vielen Dank!";
        }

        //var form = document.getElementById('os-question-form');
        //form && form.scrollIntoView({behavior:"smooth", block:"start"});
        });
    }

    // ----------------------------------------------------
    // SUPPORT BUTTON (Adresse kaputt oder force_contact)
    // Öffnet Formular + Prefill + scroll
    // ----------------------------------------------------
    function bindSupportButton__(order, prodUI){
        var btn = document.getElementById('os-support-btn');
        if (!btn) return;

        btn.addEventListener('click', function(){
        var subjEl = document.getElementById('os-question-subject');
        var textEl = document.getElementById('os-question-text');

        showQuestionForm();

        var prefill = prodUI.supportPrefill || {
            subject: "#" + (order.number || "") + " - Support Anfrage",
            message:
            "Hallo SmilePoster-Team,\n\n" +
            "ich habe eine Frage zu meiner Bestellung #" + (order.number || "") + ".\n\n" +
            "[HIER FRAGE EINGEBEN]\n\n" +
            "Vielen Dank!"
        };

        if (subjEl && !subjEl.value.trim()) subjEl.value = prefill.subject;
        if (textEl && !textEl.value.trim()) textEl.value = prefill.message;

        var form = document.getElementById('os-question-form');
        form && form.scrollIntoView({behavior:"smooth", block:"start"});
        });
    }

    function bindSupportButton(order, prodUI){
    var btn = document.getElementById('os-support-btn');
    if (!btn) return;

    btn.addEventListener('click', function(){
        var subjEl = document.getElementById('os-question-subject');
        var textEl = document.getElementById('os-question-text');

        showQuestionForm();

        // ✅ 1) Wenn Halt-Draft existiert (nach CANCELLED), nimm den:
        var prefill = order._halt_prefill || prodUI.supportPrefill || {
        subject: "#" + (order.number || "") + " - Support Anfrage",
        message:
            "Hallo SmilePoster-Team,\n\n" +
            "ich habe eine Frage zu meiner Bestellung #" + (order.number || "") + ".\n\n" +
            "[HIER FRAGE EINGEBEN]\n\n" +
            "Vielen Dank!"
        };

        if (subjEl && !subjEl.value.trim()) subjEl.value = prefill.subject;
        if (textEl && !textEl.value.trim()) textEl.value = prefill.message;

        var form = document.getElementById('os-question-form');
        form && form.scrollIntoView({behavior:"smooth", block:"start"});
    });
    }

    // ----------------------------------------------------
    // Requirement #1:
    // MerchOne ACCEPTED -> Button "Druckauftrag anhalten"
    // -> echter Halt via Backend falls cancelEndpoint vorhanden,
    //    sonst nur Mailformular-Prefill.
    // Danach immer zum Formular scrollen.
    // ----------------------------------------------------
    function bindMerchOneHaltHandler(order){
        var btn = document.getElementById('os-halt-btn'); // dein Button im Production-Card HTML
        if (!btn) return;

        var modal   = document.getElementById('os-halt-modal');
        var closeX  = document.getElementById('os-halt-close');
        var cancel  = document.getElementById('os-halt-cancel');
        var confirm = document.getElementById('os-halt-confirm');
        var backdrop = modal && modal.querySelector('.os-modal-backdrop');

        function openModal(){
            if (!modal) return;
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        }

        function closeModal(){
            if (!modal) return;
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
            setConfirmLoading(false);
        }

        function setConfirmLoading(isLoading){
            if (!confirm) return;
            confirm.disabled = !!isLoading;
            confirm.textContent = isLoading ? "Bitte warten..." : "Ja, Druckauftrag anhalten";
        }

        // Klick auf Button -> nur Modal öffnen
        btn.addEventListener('click', function(){
            // falls bereits cancelled oder nicht allowed
            var prod = order.production || {};
            if (prod.status === "CANCELLED" || prod.cancellable === false) return;

            openModal();
        });

        // Modal Close Actions
        closeX && closeX.addEventListener('click', closeModal);
        cancel && cancel.addEventListener('click', closeModal);
        backdrop && backdrop.addEventListener('click', closeModal);

        console.log(order);

        // Confirm -> erst jetzt Backend call
        confirm && confirm.addEventListener('click', function(){
            setConfirmLoading(true);

            fetch(window.ORDER_STATUS_CONFIG.cancelEndpoint, {
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body: JSON.stringify({
                    orderNumber: order.number
                })
            })
            .then(r => r.json())
            .then(data => {
                if (!data || !data.success){
                    alert((data && data.message) ? data.message : "Abbruch nicht möglich.");
                    setConfirmLoading(false);
                    return;
                }

                order.production = data.production || order.production;

                // ✅ Draft vorbereiten, aber NICHT öffnen / scrollen
                prefillHaltDraft(order);

                closeModal();

                renderOrder(order);
                hideLoginIntroButKeepResult();
            })
            .catch(() => {
                //alert("Technischer Fehler beim Anhalten. Bitte später erneut versuchen.");
                //setConfirmLoading(false);
            });
        });

        // ESC schließt Modal
        document.addEventListener('keydown', function(e){
            if (e.key === "Escape" && modal && modal.style.display === 'block'){
            closeModal();
            }
        });
    }

    function prefillHaltDraft(order) {
        var nr = (order && order.number) ? String(order.number).replace(/^#/, '') : '';
        order._halt_prefill = {
        subject: "#" + nr + " - Druckauftrag angehalten",
        message:
            "Hallo SmilePoster-Team,\n\n" +
            "ich habe den Druckauftrag zu Bestellung #" + nr + " angehalten.\n\n" +
            "Und zwar aus folgendem Grund:\n\n" +
            "[HIER DEN GRUND ANGEBEN]\n\n" +
            "Vielen Dank!"
        };
    }

    // ----------------------------------------------------
    // IMAGE MODAL
    // ----------------------------------------------------
    function bindImageModal(){
        var backdrop = document.getElementById('os-modal-backdrop');
        var modalImg = document.getElementById('os-modal-img');
        var closeBtn = document.getElementById('os-modal-close');
        if (!backdrop || !modalImg || !closeBtn) return;

        result.querySelectorAll('img[data-zoom]').forEach(function(img){
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function(){
            modalImg.src = img.dataset.zoom;
            backdrop.style.display = 'flex';
        });
        });

        function close(){
        backdrop.style.display = 'none';
        modalImg.src = '';
        }

        closeBtn.addEventListener('click', close);
        backdrop.addEventListener('click', function(e){
        if (e.target === backdrop) close();
        });
    }

    // ----------------------------------------------------
    // PRODUCTION UI from Payload (minimal, nicht redundant)
    // ----------------------------------------------------
    function computeProductionUI(prod){
        prod = prod || {};
        var label = prod.label || "Bearbeitung läuft";
        var hint  = prod.hint  || "";
        var color = prod.color || "gray";

        var colorClass =
        color === "red"    ? "os-red" :
        color === "green"  ? "os-green" :
        color === "orange" ? "os-orange" :
                            "os-gray";

        return {
        label: label,
        hint: hint,
        colorClass: colorClass,
        cancellable: !!prod.cancellable,
        showSupportButton: false,
        supportPrefill: null
        };
    }

    // ----------------------------------------------------
    // ADDRESS VALIDATION (Fallback)
    // Requirement #2: Keine Hausnummer / unvollständig → rot
    // ----------------------------------------------------
    function checkAddressIssue(addr){
        if (!addr) return {issue:true, reason:"Lieferadresse fehlt."};

        var a1 = (addr.address1 || '').trim();
        var zip = (addr.zip || '').trim();
        var city = (addr.city || '').trim();
        var country = (addr.country || '').trim();

        if (!a1 || !zip || !city || !country) {
        return {issue:true, reason:"Lieferadresse fehlerhaft oder unvollständig."};
        }

        // Hausnummer fehlt, wenn keine Ziffer im address1
        if (!/\d/.test(a1)) {
        return {issue:true, reason:"In deiner Lieferadresse fehlt die Hausnummer."};
        }

        return {issue:false, reason:""};
    }

    // ----------------------------------------------------
    // SAFE HELPERS
    // ----------------------------------------------------
    function safe(v){
        return (v === null || v === undefined) ? '' : String(v);
    }

});
